import React, { useState, useEffect } from 'react';
import axios from 'axios';
import queryString from 'query-string';

import { ERROR_RETRY } from '../../../lib/Error';
import { BABYFACE_URL } from '../../../lib/routes/Routes';
import ReviewItemView from '../Item/ReviewItemView';
import { useInfiniteScroll } from '../../../Hooks/useScroll';
import Loading from '../../../components/common/organism/Loading';
import { getReviewListApi } from './ReviewList';
import { Flex } from '../../../components/common/atom/Layout';
import ThemeStyle from '../../../lib/style/ThemeStyle';

const ReviewListView = ({ criteria, sortBy, sortDirection }) => {
  const [reviewList, setReviewList] = useState([]);
  const [target, setTarget] = useState(null);
  const [loading, setLoading] = useState(false);
  const size = 10;
  const [page, setPage] = useState(null);
  const [totalPages, setTotalPages] = useState(null);

  useEffect(() => {
    setReviewList([]);
    setLoading(false);
    setPage(0);
    setTotalPages(1);
  }, [criteria, sortBy, sortDirection]);

  useInfiniteScroll({
    target,
    onIntersect: ([{ isIntersecting }]) => {
      if (isIntersecting) {
        if (loading) return;
        if (page < totalPages) {
          setPage((page) => page + 1);
          onScroll();
        }
      }
    },
  });

  const onScroll = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        BABYFACE_URL.concat(
          getReviewListApi.concat(
            `?${queryString.stringify({
              criteria,
              sortBy,
              sortDirection,
              page,
              size,
              getAllImages: true,
            })}`,
          ),
        ),
      );
      setReviewList((reviewList) => reviewList.concat(response.data.content));
      setLoading(false);
      setTotalPages((totalPages) => response.data.totalPages);
    } catch (e) {
      alert(ERROR_RETRY);
    }
  };

  return (
    <>
      {reviewList.map((review) => (
        <Flex
          key={review.id}
          width="100%"
          column
          alignItems="stretch"
          padding="0.625rem 0 0"
          style={{
            borderTop: `1px solid ${ThemeStyle.color.pinkishGrey}`,
            marginTop: '0.625rem',
          }}
        >
          <ReviewItemView data={review} singleMode={false} />
        </Flex>
      ))}
      <div ref={setTarget}></div>
      {loading && <Loading />}
    </>
  );
};

export default React.memo(ReviewListView);
